export default __webpack_public_path__ + "static/media/bg_end_meeting.0508b67a.png";